module.exports = __webpack_public_path__ + "static/media/pattern9.cbb5867a.svg";